import GrpcRioClient from '.';
import { noWindow } from '../../utils';
var initClient = function initClient() {
  if (!noWindow() && !window.rioClient2 && !GrpcRioClient.isInit) {
    GrpcRioClient.isInit = true;
    window.rioClient2 = new GrpcRioClient();
  }
};
export default initClient;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/rio2-web-client/dist/esm/client/grpc/initClient.js
// module id = 4155
// module chunks = 11